import StyledEngineProvider from "@mui/material/StyledEngineProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { SnackbarProvider } from "notistack";
import React, { ReactNode } from "react";

import { ApolloClientProvider } from "./ApolloClientProvider";
import { ThemeProvider } from "./ThemeProvider";

import { LanguageProvider } from "components/providers/LanguageProvider";

import { AuthProvider } from "contexts/AuthContext";
import { IntlProvider } from "contexts/IntlContext";
import { MFAProvider } from "contexts/MFAContext";
import { SettingsProvider } from "contexts/SettingsContext";

const stripePromise = loadStripe(process.env.NEXT_PUBLIC_STRIPE_KEY ?? "");

interface ProvidersProps {
  children: ReactNode;
}

export const Providers: React.FC<ProvidersProps> = ({ children }) => (
  <ApolloClientProvider>
    <IntlProvider>
      <SnackbarProvider dense maxSnack={3}>
        <StyledEngineProvider injectFirst>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <SettingsProvider>
              <AuthProvider>
                <MFAProvider>
                  <Elements stripe={stripePromise}>
                    <ThemeProvider>
                      <LanguageProvider>{children}</LanguageProvider>
                    </ThemeProvider>
                  </Elements>
                </MFAProvider>
              </AuthProvider>
            </SettingsProvider>
          </LocalizationProvider>
        </StyledEngineProvider>
      </SnackbarProvider>
    </IntlProvider>
  </ApolloClientProvider>
);
